import { render, staticRenderFns } from "./TipoPedido.vue?vue&type=template&id=37c6bc10"
import script from "./TipoPedido.vue?vue&type=script&lang=js"
export * from "./TipoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports